import { render } from "./PolandTaxResidenceField.vue?vue&type=template&id=72294090&scoped=true&ts=true"
import script from "./PolandTaxResidenceField.vue?vue&type=script&lang=ts"
export * from "./PolandTaxResidenceField.vue?vue&type=script&lang=ts"

import "./PolandTaxResidenceField.vue?vue&type=style&index=0&id=72294090&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72294090"]])

export default __exports__